import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './PendingUsers.css';

const PendingUsers = () => {
    const [pendingUsers, setPendingUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchPendingUsers();
    }, []);

    const fetchPendingUsers = async () => {
        try {
            const token = localStorage.getItem('discord_token');
            const API_BASE = process.env.REACT_APP_API_BASE;
            const response = await axios.get(`${API_BASE}/api/pending-users`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setPendingUsers(response.data);
            setLoading(false);
        } catch (err) {
            console.error('Error fetching pending users:', err);
            const errorMessage = err.response?.data?.error || err.response?.data?.message || 'Fehler beim Laden der ausstehenden Benutzer';
            setError(errorMessage);
            setLoading(false);
        }
    };

    const handleApprove = async (userId) => {
        try {
            const token = localStorage.getItem('discord_token');
            const API_BASE = process.env.REACT_APP_API_BASE;
            await axios.post(`${API_BASE}/api/approve-user`,
                { userId },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            // Remove approved user from list
            setPendingUsers(prev => prev.filter(u => u.user_id !== userId));
        } catch (err) {
            alert('Fehler beim Freischalten: ' + (err.response?.data?.error || err.message));
        }
    };

    const handleReject = async (userId) => {
        try {
            const token = localStorage.getItem('discord_token');
            const API_BASE = process.env.REACT_APP_API_BASE;
            await axios.post(`${API_BASE}/api/reject-user`,
                { userId },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            // Remove rejected user from list
            setPendingUsers(prev => prev.filter(u => u.user_id !== userId));
        } catch (err) {
            alert('Fehler beim Ablehnen: ' + (err.response?.data?.error || err.message));
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleDateString('de-DE', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    if (loading) {
        return (
            <div className="card">
                <div className="card-header">
                    <h3>⏳ Ausstehende Benutzer</h3>
                </div>
                <div className="card-body">
                    <p>Lädt...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="card">
                <div className="card-header">
                    <h3>❌ Ausstehende Benutzer</h3>
                </div>
                <div className="card-body">
                    <p style={{ color: '#ff6b6b' }}>{error}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="card">
            <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h3>⏳ Ausstehende Benutzer</h3>
                <span className="badge badge-warning">{pendingUsers.length}</span>
            </div>
            
            <div className="card-body">
                {pendingUsers.length === 0 ? (
                    <p style={{ color: '#888', textAlign: 'center', padding: '20px' }}>
                        Keine ausstehenden Benutzer. Alle Anträge wurden bearbeitet.
                    </p>
                ) : (
                    <table className="admin-table">
                        <thead>
                            <tr>
                                <th>Benutzer</th>
                                <th>Discord ID</th>
                                <th>Angemeldet am</th>
                                <th>Letzter Login</th>
                                <th>Aktionen</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pendingUsers.map(user => (
                                <tr key={user.user_id} style={{ borderBottom: '1px solid #222' }}>
                                    <td style={{ padding: '12px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <img
                                                src={user.avatar_url || `https://cdn.discordapp.com/embed/avatars/0.png`}
                                                alt="Avatar"
                                                style={{ width: '32px', height: '32px', borderRadius: '50%', marginRight: '10px' }}
                                            />
                                            <div>
                                                <div style={{ fontWeight: 'bold' }}>
                                                    {user.global_name || user.username}
                                                </div>
                                                <div style={{ fontSize: '0.8rem', color: '#888' }}>
                                                    @{user.username}
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style={{ padding: '12px', color: '#888', fontFamily: 'monospace' }}>
                                        {user.user_id}
                                    </td>
                                    <td style={{ padding: '12px' }}>
                                        {formatDate(user.created_at)}
                                    </td>
                                    <td style={{ padding: '12px' }}>
                                        {formatDate(user.last_login)}
                                    </td>
                                    <td style={{ padding: '12px' }}>
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            <button
                                                onClick={() => handleApprove(user.user_id)}
                                                className="btn btn-success"
                                                style={{ 
                                                    background: '#28a745', 
                                                    color: '#fff', 
                                                    border: 'none', 
                                                    padding: '8px 16px', 
                                                    borderRadius: '4px',
                                                    cursor: 'pointer',
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                                ✓ Freischalten
                                            </button>
                                            <button
                                                onClick={() => handleReject(user.user_id)}
                                                className="btn btn-danger"
                                                style={{ 
                                                    background: '#dc3545', 
                                                    color: '#fff', 
                                                    border: 'none', 
                                                    padding: '8px 16px', 
                                                    borderRadius: '4px',
                                                    cursor: 'pointer',
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                                ✗ Ablehnen
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

export default PendingUsers;
